import React from 'react'
import GenericTitleP from '../../titles/GenericTitleP'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPortrait } from '@fortawesome/free-solid-svg-icons'


const p = [
  {id:1, total: 3976, memberSince: "March 2021", username:"Member 1", email: "example@gmail.com"},
  {id:2, total: 3600, memberSince: "June 2021", username:"Member 2", email: "example@gmail.com"},
  {id:3, total: 3273, memberSince: "June 2021", username:"Member 3", email: "example@gmail.com"},
  {id:4, total: 2712, memberSince: "March 2021", username:"Member 4", email: "example@gmail.com"},
  {id:5, total: 2700, memberSince: "May 2021", username:"Member 5", email: "example@gmail.com"},
  {id:6, total: 2376, memberSince: "March 2021", username:"Member 6", email: "example@gmail.com"},
  {id:7, total: 2226, memberSince: "December 2021", username:"Member 7", email: "example@gmail.com"},
  {id:8, total: 2136, memberSince: "January 2022", username:"Member 8", email: "example@gmail.com"},
  {id:9, total: 1840, memberSince: "March 2022", username:"Member 9", email: "example@gmail.com"},
  {id:10, total: 1608, memberSince: "April 2021", username:"Member 10", email: "example@gmail.com"},
]
const TopTenBuyers = () => {

  return (
    <div className='text-center'>
      <GenericTitleP>Top Ten Buyers</GenericTitleP>
      <div className='d-flex flex-wrap w-100 p-2 justify-content-center'>
        {p.map(p => <div style={{flexGrow:"1", maxWidth: "200px"}} className='shadow rounded d-flex flex-column align-items-center m-2 m-md-4 p-2 p-md-4'>
          <FontAwesomeIcon style={{color:"turquoise",zIndex: ""}} className='mb-4  w-100 h-100 top-0 ' icon={faPortrait} /> 
          <p>{p.username}</p>
          <p>{p.total} $</p>
          <div style={{background:"turquoise", padding:"1px"}} className='w-100 mb-2'></div>
          <p>Member Since {p.memberSince}</p>
        </div>)}
      </div>
    </div>
  )
}

export default TopTenBuyers